.error-fallback {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  background-color: #f5f5f5;
}

.error-fallback-content {
  max-width: 600px;
  width: 100%;
  background: white;
  border-radius: 8px;
  padding: 40px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.error-fallback-content h1 {
  color: #d32f2f;
  margin-top: 0;
  margin-bottom: 16px;
  font-size: 28px;
}

.error-message {
  color: #666;
  margin-bottom: 24px;
  font-size: 16px;
  line-height: 1.5;
}

.error-details {
  margin: 24px 0;
  padding: 16px;
  background-color: #f5f5f5;
  border-radius: 4px;
  border: 1px solid #ddd;
}

.error-details summary {
  cursor: pointer;
  font-weight: 600;
  margin-bottom: 8px;
  color: #333;
}

.error-details pre {
  margin: 8px 0 0 0;
  padding: 12px;
  background-color: #fff;
  border-radius: 4px;
  overflow-x: auto;
  font-size: 12px;
  color: #d32f2f;
  white-space: pre-wrap;
  word-wrap: break-word;
}

.error-actions {
  display: flex;
  gap: 12px;
  margin-bottom: 32px;
  padding-top: 24px;
  border-top: 1px solid #eee;
}

.btn-try-again,
.btn-go-home {
  padding: 12px 24px;
  border: none;
  border-radius: 4px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s;
}

.btn-try-again {
  background-color: #1976d2;
  color: white;
}

.btn-try-again:hover:not(:disabled) {
  background-color: #1565c0;
}

.btn-go-home {
  background-color: #f5f5f5;
  color: #333;
}

.btn-go-home:hover:not(:disabled) {
  background-color: #e0e0e0;
}

.feedback-form {
  margin-top: 32px;
  padding-top: 32px;
  border-top: 2px solid #eee;
}

.feedback-form h2 {
  margin-top: 0;
  margin-bottom: 8px;
  font-size: 20px;
  color: #333;
}

.feedback-prompt {
  color: #666;
  margin-bottom: 24px;
  font-size: 14px;
  line-height: 1.5;
}

.form-group {
  margin-bottom: 20px;
}

.form-group label {
  display: block;
  margin-bottom: 8px;
  font-weight: 500;
  color: #333;
  font-size: 14px;
}

.form-group textarea,
.form-group input[type="email"] {
  width: 100%;
  padding: 12px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
  font-family: inherit;
  box-sizing: border-box;
}

.form-group textarea {
  resize: vertical;
  min-height: 100px;
}

.form-group textarea:focus,
.form-group input[type="email"]:focus {
  outline: none;
  border-color: #1976d2;
  box-shadow: 0 0 0 2px rgba(25, 118, 210, 0.1);
}

.form-group textarea:disabled,
.form-group input[type="email"]:disabled {
  background-color: #f5f5f5;
  cursor: not-allowed;
}

.form-group small {
  display: block;
  margin-top: 4px;
  color: #666;
  font-size: 12px;
}

.btn-submit-feedback {
  width: 100%;
  padding: 12px 24px;
  background-color: #1976d2;
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s;
}

.btn-submit-feedback:hover:not(:disabled) {
  background-color: #1565c0;
}

.btn-submit-feedback:disabled {
  background-color: #ccc;
  cursor: not-allowed;
}

.feedback-success {
  margin-top: 32px;
  padding: 16px;
  background-color: #e8f5e9;
  border: 1px solid #4caf50;
  border-radius: 4px;
  color: #2e7d32;
  text-align: center;
}

.feedback-success p {
  margin: 0;
  font-size: 14px;
}

